import { AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import { useTranslation } from 'react-i18next';

interface ChartPoint {
    name: string;
    calls?: number;
    meetings?: number;
}

interface PerformanceChartProps {
    compact?: boolean;
    data?: ChartPoint[];
}

export default function PerformanceChart({ data }: PerformanceChartProps) {
    const { t } = useTranslation(['admin']);
    if (!data || data.length === 0) {
        return (
            <div className="h-[300px] w-full flex items-center justify-center">
                <p className="text-sm text-gray-400">{t('admin:backoffice.performanceChart.noData')}</p>
            </div>
        );
    }

    const chartData = data;

    return (
        <div className="h-[300px] w-full">
            <ResponsiveContainer width="100%" height="100%">
                <AreaChart data={chartData} margin={{ top: 10, right: 10, left: -20, bottom: 0 }}>
                    <defs>
                        <linearGradient id="colorCalls" x1="0" y1="0" x2="0" y2="1">
                            <stop offset="5%" stopColor="#8b5cf6" stopOpacity={0.3}/>
                            <stop offset="95%" stopColor="#8b5cf6" stopOpacity={0}/>
                        </linearGradient>
                        <linearGradient id="colorMeetings" x1="0" y1="0" x2="0" y2="1">
                            <stop offset="5%" stopColor="#22c55e" stopOpacity={0.3}/>
                            <stop offset="95%" stopColor="#22c55e" stopOpacity={0}/>
                        </linearGradient>
                    </defs>
                    <CartesianGrid strokeDasharray="3 3" stroke="#f1f5f9" />
                    <XAxis dataKey="name" tick={{ fontSize: 12, fill: '#94a3b8' }} axisLine={false} tickLine={false} />
                    <YAxis tick={{ fontSize: 12, fill: '#94a3b8' }} axisLine={false} tickLine={false} />
                    <Tooltip
                        contentStyle={{
                            backgroundColor: '#fff',
                            border: '1px solid #e2e8f0',
                            borderRadius: '12px',
                            boxShadow: '0 4px 6px -1px rgb(0 0 0 / 0.1)'
                        }}
                    />
                    <Area
                        type="monotone"
                        dataKey="calls"
                        name={t('admin:backoffice.performance.calls')}
                        stroke="#8b5cf6"
                        strokeWidth={2}
                        fillOpacity={1}
                        fill="url(#colorCalls)"
                    />
                    <Area
                        type="monotone"
                        dataKey="meetings"
                        name={t('admin:backoffice.smartActions.meetings')}
                        stroke="#22c55e"
                        strokeWidth={2}
                        fillOpacity={1}
                        fill="url(#colorMeetings)"
                    />
                </AreaChart>
            </ResponsiveContainer>
        </div>
    );
}